import { render } from "./RevenuePage.vue?vue&type=template&id=46a3e5ad&scoped=true"
import script from "./RevenuePage.vue?vue&type=script&lang=js"
export * from "./RevenuePage.vue?vue&type=script&lang=js"

import "./RevenuePage.vue?vue&type=style&index=0&id=46a3e5ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a3e5ad"]])

export default __exports__